<template>
  <AppSection id="scopes" :title="$getConst.pages.scope.scopes" type="page">
    <AppSection
      id="permissions-table"
      :title="$t($getConst.pages.scope.list_of_scopes)"
      type="section"
      :button="hasPermission($getConst.permissions.createScope)"
      :button-text="$getConst.pages.button.add"
      :button-icon="$getConst.icons.add"
      @onClick="openScopeModal"
    >
      <AppDataTable
        ref="scopesTable"
        :fields="fields"
        :actions="actions"
        end-point="/scopes"
        @onDelete="confirmDelete"
        @onEdit="edit"
        @onSetting="onSetting"
      >
        <template v-slot:status="item">
          <b-badge class="gradient" pill :variant="(item.data === 'work' || item.data === 'live') ? 'secondary' : 'warning'">{{$t($getConst.pages.scope[item.data])}}</b-badge>
        </template>
        <template v-slot:language_id="item">
          <lang-flag v-if="item.data.code" :iso="item.data.code" :squared="false"/>{{item.data.name}}
        </template>
      </AppDataTable>
      <ScopeModal :id="scopeAddModal" :languages="languages"/>
      <ScopeModal :id="scopeEditModal" :scope-to-edit="scopeToEdit" :languages="languages"/>
      <AppConfirmationModal
        id="confirmation-modal"
        :title=$t($getConst.pages.profile.are_you_sure) | capitalize
        ref="confirmDelete"
        @onCancel="cancelDelete"
        @onConfirm="deleteScope"/>
    </AppSection>
  </AppSection>
</template>

<script>
  import AppDataTable from "../../../components/common/table/AppDataTable";
  import {deleteScope} from "../../../api/scopes.api";
  import ScopeModal from "./ScopeModal";
  import AppSection from "../../../components/common/sections/AppSection";
  import AppConfirmationModal from "../../../components/common/modals/AppConfirmationModal";
  import LangFlag from 'vue-lang-code-flags';
  import {getAllLanguages} from "../../../api/languages.api";


  export default {
    name: "index",
    components: {AppSection, AppConfirmationModal, ScopeModal, AppDataTable, LangFlag},
    data() {
      return {
        scopeToDelete: null,
        scopeToEdit: null,
        scopeEditModal: 'scope-edit-modal',
        scopeAddModal: 'scope-add-modal',
        fields: [
          {key: 'name', sortable: true, filterable: true},
          {key: 'status', label: 'status' ,sortable: true, filterable: true},
          {key: 'language_id', label: 'language',sortable: true, filterable: true},
          {key: 'nav_scope_id', label: 'Navision ID' ,sortable: true, filterable: true},
          {key: 'timezone', sortable: true, filterable: true},
        ],
        actions: [
          {action: 'onEdit', variant: 'outline-secondary', icon: this.$getConst.icons.edit, permissions: [this.$getConst.permissions.writeScope]},
          {action: 'onDelete', variant: 'outline-danger', icon: this.$getConst.icons.delete, permissions: [this.$getConst.permissions.deleteScope]},
          {
            action: 'onSetting',
            variant: 'outline-warning',
            icon: this.$getConst.icons.setting,
            permissions: [
              this.$getConst.permissions.writeTranslation, // For edit maintenance and error pages
              this.$getConst.permissions.writeHelpContents,
              this.$getConst.permissions.writeEmailTemplate,
              this.$getConst.permissions.readEmailTemplate,
            ]
          },
        ],
        languages : [],
        statuses: [this.$getConst.pages.scope.live, this.$getConst.pages.scope.maintenance]
      }
    },
    mounted() {
      this.$root.$on('onAddScope', scope => {
        this.onAddScope(scope);
      });
      this.$root.$on('onEditScope', scope => {
        this.onEditScope(scope);
      });
    },
    methods: {
      confirmDelete(scope) {
        this.scopeToDelete = scope;
        this.$bvModal.show('confirmation-modal')
      },
      cancelDelete() {
        this.scopeToDelete = null;
      },
      deleteScope() {
        deleteScope(this.scopeToDelete.id).then(
          () => {
            this.$refs.scopesTable.removeItem(this.scopeToDelete);
            this.$refs.confirmDelete.close();
            this.$snotify.success(this.$t(this.$getConst.pages.scope.scope_deleted));
          },
          (error) => {
            this.handleApiError(error);
          }
        )
      },
      edit(scope) {
        this.scopeToEdit = Object.assign({}, scope);
        this.openScopeEditModal();
      },
      onEditScope(scope) {
        this.$snotify.success(this.$t(this.$getConst.pages.scope.scope_updated));
        this.$refs.scopesTable.editItem(scope);
      },
      onSetting(scope) {
        this.$router.push(
          {
            name: this.$getConst.routesNames.administration.scopeDashboard,
            params: {
              scope_id: scope.id,
              scope_name: scope.name
            }
          }
        );
      },
      onAddScope(scope) {
        this.$snotify.success(this.$t(this.$getConst.pages.scope.scope_added));
        this.$refs.scopesTable.addItem(scope);
      },
      openScopeModal() {
        this.$bvModal.show(this.scopeAddModal);
      },
      openScopeEditModal() {
        this.$bvModal.show(this.scopeEditModal);
      },
      getLanguagesList() {
        getAllLanguages(false).then(listOfLanguages=> {
          this.languages = listOfLanguages.data;
          this.updateFields(this.languages);
        })
      },
      updateFields(languages) {
        this.fields[2].filterable = languages.map(language=> {
          return {value: language.id, text: language.name};
        });
      },
      getStatusesList() {
         this.fields[1].filterable = this.statuses.map(status=> {
          return {value: status, text: status.toUpperCase()};
        });
      }
    },
    created() {
      this.getLanguagesList();
      this.getStatusesList();
    },
    beforeDestroy() {
      this.$root.$off('onAddScope');
      this.$root.$off('onEditScope');
    }
  }
</script>

<style scoped>
  .badge {
    height: inherit;
    width: 80%;
  }
</style>
